import * as React from 'react';
import { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import CompareModeHeader from '../CompareModeHeader/CompareModeHeader';
import * as actions from '../../../../redux/diffMode/actions.diffMode';
import * as _ from 'lodash';
import projectHelper from '../../../../services/ProjectHelper';
import CompareScriptArea from '../CompareScriptArea/CompareScriptArea';
import CompareScriptsPanel from '../CompareScriptsPanel/CompareScriptsPanel';
import getProjectId from '../../../../services/mini/getProjectId';
import { IProject } from '../../../../models/IProject';
import { ICompredScript } from '../../../../models/ICompredScript';
import { ICompareVersionsParams, IFillDiffModeParams } from '../../../../redux/diffMode/saga.diffMode';
import { IChangeSelectedScriptParams } from '../../../../redux/diffMode/actions.diffMode';
import NoContentView from '../../../components/NoContentView/NoContentView';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
const { default: noChangesIcon } = require('../../../../assets/images/diff/no-changes-script-pic@2x.png');

type CompareModePageProps = {
    project: IProject
    projectId: string
    scripts: ICompredScript[]
    fromTagId: string
    toTagId: string
    diffModeScriptsUpdateTs: number
    selectedScript: ICompredScript
    isLoading: boolean
    fontSize: string
    codeTheme: string
    fillDiffMode: (param: IFillDiffModeParams) => void
    changeSelectedScript: (param: IChangeSelectedScriptParams) => void
    compareVersions: (param: ICompareVersionsParams) => void
}

function CompareModePage({
    project,
    projectId,
    scripts,
    fromTagId,
    toTagId,
    selectedScript,
    isLoading,
    fontSize,
    codeTheme,
    changeSelectedScript,
    fillDiffMode,
    compareVersions,
}: CompareModePageProps) {

    const environment = projectHelper.getEnvironment(projectId);

    useEffect(() => {
        fillDiffMode({ projectId, environment });
    }, [environment, fillDiffMode, projectId]);

    const compareVersionsCb = useCallback((fromTagId, toTagId) => {
        compareVersions({ projectId, fromTagId, toTagId });
    }, [compareVersions, projectId]);

    return (
        <div className={`compare-mode-page font-${fontSize} ${codeTheme}`}>
            <MainHeader environment={environment}>
                <CompareModeHeader
                    environment={environment}
                    project={project}
                    compareVersions={compareVersionsCb}
                    fromTagId={fromTagId}
                    toTagId={toTagId} />
            </MainHeader>

            <div className="compare-mode-page_diff-area">

                {isLoading ?
                    <Loader theme={LoaderTheme.Dark} size={LoaderSize.Medium} center={true} appearWithFade={true} /> :
                    <>
                        {_.isEmpty(scripts) ?
                            <NoContentView img={noChangesIcon} label={`No changes have been made.`} /> :
                            <>
                                <CompareScriptsPanel
                                    scripts={scripts}
                                    isLoading={isLoading}
                                    changeSelectedScript={changeSelectedScript}
                                    selectedScript={selectedScript} />
                                <CompareScriptArea
                                    isLoading={isLoading}
                                    script={selectedScript}
                                />
                            </>}
                    </>}
            </div>
        </div>
    );
}

function mapStateToProps({ projectsInfo, diffMode, scriptEditor }, ownProps) {
    return {
        projectId: getProjectId(ownProps.params.projectName, projectsInfo.projects),
        project: projectsInfo.currentProject,
        projects: projectsInfo.projects,
        scripts: diffMode.scripts,
        fromTagId: diffMode.fromTagId,
        toTagId: diffMode.toTagId,
        diffModeScriptsUpdateTs: diffMode.diffModeScriptsUpdateTs,
        selectedScript: diffMode.selectedScript,
        isLoading: diffMode.isLoading,
        fontSize: scriptEditor.fontSize,
        codeTheme: scriptEditor.codeTheme
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fillDiffMode: (param) => dispatch(actions.fillDiffMode(param)),
        compareVersions: (param) => dispatch(actions.compareVersions(param)),
        changeSelectedScript: (param) => dispatch(actions.changeSelectedScript(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompareModePage);
